import { cn } from "@productlane/lib/src/browser"

export type ChatInputSubmitIcon = "paper-plane" | "arrow-up"

// The idle submit arrow, the mic and the paperclip share this so the row reads as one set.
export const CHAT_INPUT_IDLE_ICON_COLOR = "text-gray-600 dark:text-gray-300"

export const chatInputSubmitIconClasses = ({
	sendEnabled,
}: {
	submitIcon: ChatInputSubmitIcon
	sendEnabled: boolean
}) =>
	cn(
		"h-4 w-4",
		sendEnabled ? "text-white dark:text-gray-900" : CHAT_INPUT_IDLE_ICON_COLOR,
	)

// A CSS square, not the stop SVG: that glyph's 14/18 rect falls on fractional
// pixels and snaps a device pixel off center in the 26px button.
export const chatInputStopIconClasses = () =>
	cn("h-2.5 w-2.5 rounded-[2px] bg-white dark:bg-gray-900")

export const chatInputAttachIconClasses = () =>
	cn("h-4 w-4 flex-none", CHAT_INPUT_IDLE_ICON_COLOR)

// Thinner than the button default: at 16px the paperclip's inner curl fills in
// once its strokes touch.
export const CHAT_INPUT_ATTACH_STROKE_WIDTH = 1.25
